/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */
export enum SystemMessageType {
  discoverPeerRequest = "discoverPeerRequest",
  discoverPeerResponse = "discoverPeerResponse",
  registerWithPeerRequest = "registerWithPeerRequest",
  registerWithPeerResponse = "registerWithPeerResponse",
  unregisterWithPeerRequest = "unregisterWithPeerRequest",
  unregisterWithPeerResponse = "unregisterWithPeerResponse",
  fdc3ApiMethodRequest = "fdc3ApiMethodRequest",
  fdc3ApiMethodResponse = "fdc3ApiMethodResponse",
}
